"use client";

import { useAddToList } from "@/app/hooks/useAddToList";
import { type StorefrontUrls } from "@/app/utilities/storefront-urls";
import { AddToListDropdown, CreateListPanel } from "@/composites/product";

import { ConnectConsultantModal } from "./ConnectConsultantModal";

export interface AddToListRootProps {
	sku: string;
	quantity: number;
	urls: StorefrontUrls;
	googleMapsApiKey?: string;
	createPanelEnabled?: boolean;
}

export function AddToListRoot({
	sku,
	quantity,
	urls,
	googleMapsApiKey,
	createPanelEnabled = false
}: AddToListRootProps) {
	const {
		isOpen,
		setOpen,
		status,
		wishlists,
		registries,
		onSelect,
		onCreateNew,
		submittingPk,
		addedPk,
		addedListName,
		viewListHref,
		errorMessage,
		createPanel,
		connectConsultant
	} = useAddToList({
		sku,
		quantity,
		createPanelEnabled,
		urls: {
			login: urls.login ?? "/login",
			createWishlist: urls.createWishlist ?? "/account/wishlist-mnt",
			createRegistry: urls.createRegistry ?? "/account/registry-mnt",
			listViewBase: urls.listView ?? "/account/wishlists"
		}
	});

	return (
		<>
			<AddToListDropdown
				isOpen={isOpen}
				onOpenChange={setOpen}
				status={status}
				wishlists={wishlists}
				registries={registries}
				onSelect={onSelect}
				onCreateNew={onCreateNew}
				submittingPk={submittingPk}
				addedPk={addedPk}
				addedListName={addedListName}
				viewListHref={viewListHref}
				errorMessage={errorMessage}
			/>
			{createPanelEnabled ? (
				<CreateListPanel
					kind={createPanel.kind}
					isOpen={createPanel.isOpen}
					onOpenChange={createPanel.onOpenChange}
					onSubmit={createPanel.onSubmit}
					status={createPanel.status}
					occasions={createPanel.occasions}
					country={createPanel.country}
					consultant={
						createPanel.consultant
							? {
									name: createPanel.consultant.name,
									location: createPanel.consultant.location
								}
							: undefined
					}
					onFindConsultant={createPanel.onFindConsultant}
					onRemoveConsultant={createPanel.onRemoveConsultant}
					errorMessage={createPanel.errorMessage}
					createdList={createPanel.createdList}
					viewListHref={createPanel.viewListHref}
					canCreateForOthers={createPanel.canCreateForOthers}
				>
					<ConnectConsultantModal
						isOpen={connectConsultant.isOpen}
						onOpenChange={connectConsultant.onOpenChange}
						onSelect={connectConsultant.onSelect}
						googleMapsApiKey={googleMapsApiKey}
					/>
				</CreateListPanel>
			) : null}
		</>
	);
}
